import { getFetchHeaders } from '../getFetchHeaders';
import { getFetchResponseData } from '../getFetchResponseData';
import { success, error } from '../utils';
import { SupportedSystems } from '@/shared';
import * as actions from './types';
import {
  engineeringEntryActions,
  projectEntryActions,
  bulkEntryActions,
} from '@/store';
import { timeBucketActions } from '..';

export const actionCreators = {
  addBulkTimeEntry: (body, type) => {
    return async (dispatch) => {
      let url = null;
      switch (type) {
        case SupportedSystems.VPIN:
          url = `api/v2/TimeTracker/projectEntries/bulk`;
          break;
        case SupportedSystems.LRS:
          url = `api/v2/TimeTracker/lrsEntries/bulk`;
          break;
        case SupportedSystems.ADMIN:
          url = `api/v2/TimeTracker/timeBucket/bulk`;
          break;
        default:
          throw new Error(`Unsupported system type: ${type}`);
      }

      if (url !== null) {
        dispatch({ type: actions.ADD_TIME_ENTRY_BULK });

        const headers = await getFetchHeaders();
        try {
          const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
          });

          const data = await getFetchResponseData(response);
          dispatch({
            type: actions.ADD_TIME_ENTRY_BULK_SUCCESS,
            payload: data,
          });
          return data;
        } catch (err) {
          dispatch({
            type: actions.ADD_TIME_ENTRY_BULK_ERROR,
            error:
              err.message ||
              'An error occurred while adding bulk time entries.',
          });
          throw err;
        }
      }
    };
  },
  copyPreviousWeek: (oid, startDate, endDate, type) => {
    return async (dispatch) => {
      const body = {
        oid: oid,
        firstDayOfSelectedWeek: startDate,
        timeEntryType: type,
      };
      try {
        const headers = await getFetchHeaders();
        const response = await fetch(
          'api/v2/TimeTracker/timeEntry/copyPreviousWeek',
          {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
          }
        );
        const result = await getFetchResponseData(response);

        if (result.item1.some((entry) => entry.timeEntryType === 'Vpin')) {
          await dispatch(
            engineeringEntryActions.getEngineeringProjectTimeEntries(
              oid,
              startDate,
              endDate,
              { skipPageLoader: true }
            )
          );
        }

        if (result.item1.some((entry) => entry.timeEntryType === 'Admin')) {
          await dispatch(
            timeBucketActions.getTimeBucketEntriesForCategory(
              oid,
              [startDate, endDate],
              1 // Assuming category ID 1 for Admin entries
            )
          );
          await dispatch(timeBucketActions.updateCategoriesToBeRefreshed([1]));
        }
        return result;
      } catch (err) {
        error(
          err.message || "An error occurred while copying last week's entries."
        );
        throw err;
      }
    };
  },

  setShowBulkEntryModal: (show) => ({
    type: actions.SET_SHOW_BULK_ENTRY_MODAL,
    show,
  }),
};
